
<template>
    <main class="page-body" aria-label="Content">
        <h1 class="sr-only">{{ currentRouteContent.title }}</h1>
        <router-view :content-data="currentRouteContent"></router-view>
    </main>
</template>

<script>
export default {
    props: {
        contentData: Object,
    },
    computed: {
        currentRouteContent() {
            return this.contentData[this.$route.name];
        },
    },
};
</script>

<style lang="scss">
    .page-body {
        flex-grow: 1;
        margin-bottom: 3rem;

        @include mq($from: md) {
            margin-bottom: $tablet-gutter;
        }

        @include mq($from: ml) {
            margin-bottom: $desktop-gutter;
        }
    }
</style>
